import React from "react";
import ExlyTable from "common/Components/ExlyTable";
import {
  getMeetingDetailsColumnConfig,
  filterConfig,
  tableChipsFormatter,
} from "./meetingDetailsTableConfig";
import { empty_state_props } from "../../ZoomAttendanceOfListing.helper";
import { ZOOM_ATTENDANCE_CONSTANTS } from "../../constants/ZoomAttendance.constants";

import { app_route_ids, app_route_keys } from "constants/urlPaths";

export const ListingMeetingDetailsTable = ({
  onViewAttendees,
  tableTitle,
  customBackAction,
  noExportButton = false,
  selected = [],
  onRowSelected,
  ...props
}) => {
  return (
    <div className="tw-w-full tw-px-0 sm:tw-px-5 tw-pt-3">
      <ExlyTable
        ra_props={{
          resource: app_route_ids[app_route_keys.zoom_attendance_of_listing],
          basePath: app_route_ids[app_route_keys.zoom_attendance_of_listing],
          hasCreate: false,
          hasEdit: false,
          hasList: true,
          hasShow: false,
          ...props,
        }}
        checkboxSelection={Boolean(true)}
        showSelectAllcheckBox={Boolean(true)}
        selected={selected}
        onRowSelected={onRowSelected}
        noExportButton={noExportButton}
        tableTitle={tableTitle}
        customBackAction={customBackAction}
        layoutProps={{
          paddingDesktop: ZOOM_ATTENDANCE_CONSTANTS.LAYOUT.PADDING_DESKTOP_ZERO,
          paddingBottom: ZOOM_ATTENDANCE_CONSTANTS.LAYOUT.PADDING_BOTTOM_60PX,
          noMobileBoxShadow: Boolean(true),
        }}
        columnConfig={getMeetingDetailsColumnConfig({
          onViewAttendees,
        })}
        tableFilters={filterConfig}
        tableChipsFormatter={tableChipsFormatter}
        borderedFields
        fieldsLeftPadded
        drawerFieldsBordered
        fieldsAlignment={
          ZOOM_ATTENDANCE_CONSTANTS.FIELDS_ALIGNMENT_SPACE_BETWEEN
        }
        drawerFieldsAlignment={
          ZOOM_ATTENDANCE_CONSTANTS.FIELDS_ALIGNMENT_SPACE_BETWEEN
        }
        recordFooterVariant={ZOOM_ATTENDANCE_CONSTANTS.FOOTER_VARIANT_SECONDARY}
        primaryKey={ZOOM_ATTENDANCE_CONSTANTS.LAYOUT.PRIMARY_KEY_SLOT}
        uniqueRowIdFieldName={ZOOM_ATTENDANCE_CONSTANTS.LAYOUT.PRIMARY_KEY_SLOT}
        {...empty_state_props}
      />
    </div>
  );
};
